import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// formating table
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// Metronic helper to done sorting-table ,select row etc.
import {
  sortCaret,
  getHandlerTableChange,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
// import * as uiHelpers from "../UserUIHelper";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { usePriceUIContext } from "../PriceUIContext";
import { fetchShopifyDataPricing } from "../../../actions/shopify-pricing/shopify";

export function PriceTable() {

  const [loader, setLoader] = useState(true);

  const { shopifyPricing } = useSelector(
    (state) => ({
      shopifyPricing:
        state.shopifyPricing && state.shopifyPricing && state.shopifyPricing.allShopify && state.shopifyPricing.allShopify.docs,
    }),
    shallowEqual
  );

  const { count } = useSelector(
    (state) => ({
      count:
        state.shopifyPricing && state.shopifyPricing && state.shopifyPricing.allShopify && state.shopifyPricing.allShopify.totalDocs,
    }),
    shallowEqual
  );

  const [searchQuery, setSearchQuery] = useState('');

  // const fuse = new Fuse(shopifyPricing ? shopifyPricing : [], {
  //   keys: ["plan_name"]
  // })

  // const results = fuse.search(searchQuery)


  let serchedResult = shopifyPricing;

  const dispatch = useDispatch();

  const priceUIContext = usePriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      setIds: priceUIContext.setIds,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      openEditPricePage: priceUIContext.openEditPricePage,
      openDeletePriceDialog: priceUIContext.openDeletePriceDialog,
    };
  }, [priceUIContext]);


  let handleOnChange = (e) => {
    const searchedVal = e.target.value;
    // const filteredRows = shopifyPricing.filter((row) => {
    //   return row.plan_name.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
    // });
    // if (searchedVal.length > 0 && filteredRows.length > 0) {
    //   serchedResult = filteredRows;
    // }
    // console.log('serchedResult before', serchedResult);
    priceUIProps.setQueryParams({
      ...priceUIProps.queryParams,
      search: searchedVal
    })
    setSearchQuery(searchedVal);
  }

  useEffect(() => {

    async function getShopifyPricingData() {
      setLoader(true);
      await dispatch(fetchShopifyDataPricing(priceUIProps.queryParams));
      setLoader(false);
    }
    getShopifyPricingData();

  }, [priceUIProps.queryParams, dispatch]);


  // Table pagination properties

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "30", value: 30 },
    // { text: "100", value: 100 },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: searchQuery !== undefined && searchQuery !== "" ? serchedResult.length : count,
    sizePerPageList: sizePerPageList,
    sizePerPage: priceUIProps.queryParams.pageSize,
    page: priceUIProps.queryParams.pageNumber,
  };

  const columns = [
    {
      dataField: "_id",
      text: "ID",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.RowIndex,
      style: { minWidth: "70px" },
      formatExtraData: {
        paginationOptions: paginationOptions,
        queryParams: priceUIProps.queryParams,
      }
    },
    {
      dataField: "plan_name",
      text: "Name",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "plan_price",
      text: "Price",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "plan_inventory",
      text: "Quantity",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.InventoryColumnFormatter,
      style: { minWidth: "150px" },
    },
    {
      dataField: "plan_type",
      text: "Plan Type",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PlanTypeColumnFormatter,
      style: { minWidth: "150px" },
    },

    // {
    //   dataField: "date",
    //   text: " Created At",
    //   sort: false,
    //   sortCaret: true,
    //   formatter: columnFormatters.CreateDateColumnFormatter,
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditPricePage: priceUIProps.openEditPricePage,
        openDeletePriceDialog: priceUIProps.openDeletePriceDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "100px",
      },
    },
  ];

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <div className="row">
                <div className="col-12">
                  <div className="form-group input-icon" >
                    <input type="text" className="form-control" value={searchQuery} onChange={handleOnChange} placeholder="Search..."></input> <span>
                      <i className="flaticon2-search-1 text-muted"></i>
                    </span>
                  </div>
                </div>
              </div>
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                data={serchedResult === null ? [] : serchedResult}
                onTableChange={
                  getHandlerTableChange(
                    priceUIProps.setQueryParams
                  )
                }
                {...paginationTableProps}
                noDataIndication={() => serchedResult === null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader && <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
